import React from 'react'
import { SVGIconProps } from '../types'
const SvgBatteryCharging30 = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M7.556 9.333v3.556l1.777-3.556h2.223v4c0 .49-.4.89-.89.89H5.334a.89.89 0 0 1-.889-.89v-4zm1.777-8v1.334h1.334c.489 0 .889.4.889.889v5.777H9.333l.89-1.777h-1.78V4L5.778 9.333H4.444V3.556c0-.49.4-.89.89-.89h1.333V1.334z"
      />
    </g>
  </svg>
)
export default SvgBatteryCharging30
